import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const ServiceChangeModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="service-change-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="service-change-modal-content"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="service-change-modal-close" 
              onClick={onClose}
              aria-label="Close announcement"
            >
              <FaTimes />
            </button>
            
            <div className="service-change-modal-body">
              <h2>Important Service Update</h2>
              <div className="service-change-modal-text">
                <p>
                  We are sorry, but effective immediately, Sky Harbor Shuttle no longer provides transportation other than for medical purposes.
                </p>
                <p>
                  We would like to extend our heartfelt thanks to everyone who rode with us to cruises, airports, and other destinations for their years of support. Your trust and loyalty have meant the world to us.
                </p>
                <p>
                  We will continue to provide exceptional Non-Emergency Medical Transportation (NEMT) services for all your healthcare transportation needs.
                </p>
              </div>
              <button 
                className="service-change-modal-button" 
                onClick={onClose}
              >
                I Understand
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ServiceChangeModal;

